import { AnimatePresence } from 'framer-motion'
import React from 'react'
import TopicSelectorOptionButton from './TopicSelectorOptionButton'
import OpacityAnimation from '@/components/animations/OpacityAnimation'
import { Button, Column, Row, Text } from '@/components/core'

export type TopicOptionsType = {
  id: string
  label: string
}

interface TopicSelectorProps {
  topics: string[]
  maxTopicsSelection: number
  onConfirm: (selectedTopics: string[]) => void
}

const TopicSelector = ({
  topics,
  maxTopicsSelection,
  onConfirm
}: TopicSelectorProps) => {
  const [selectedOptions, setSelectedOptions] = React.useState<any[]>([])
  const [confirmed, setConfirmed] = React.useState(false)

  const options =
    topics.map((topic) => {
      return {
        id: topic,
        label: topic
      }
    }) || []

  const handleOptionSelected = (id: string, label: string) => {
    const isAlreadySelected = selectedOptions?.some((topic) => topic.id === id)

    if (isAlreadySelected) {
      setSelectedOptions((prevSelected) =>
        prevSelected?.filter((topic) => topic.id !== id)
      )
    } else if (selectedOptions.length < maxTopicsSelection) {
      setSelectedOptions((prevSelected) => [...prevSelected, { id, label }])
    }
  }

  return (
    <Column className="max-w-[612px]">
      <Text.Translated
        translationKey="title_message_topic_selector"
        fontWeight="bold"
        size="sm"
        className="flex h-8 items-center !text-white"
      />
      <Row className="mt-3 flex-wrap gap-x-2 gap-y-4">
        {options?.map((option) => {
          const isSelected = selectedOptions.some(
            (topic) => topic.id === option.id
          )

          return (
            <TopicSelectorOptionButton
              key={option.id}
              option={option}
              handleOptionSelected={handleOptionSelected}
              isSelected={isSelected}
            />
          )
        })}
      </Row>
      <Row className="h-20 w-full py-5">
        <AnimatePresence>
          {!confirmed ? (
            <OpacityAnimation className="flex w-full flex-col">
              <Button.Translated
                translationKey="confirm_topic_button_topic_selector"
                color="flat-light"
                variant="outline"
                size="sm"
                pending={confirmed}
                onClick={() => {
                  if (selectedOptions.length >= maxTopicsSelection) {
                    onConfirm(selectedOptions.map((opt) => opt.id))
                    setConfirmed(true)
                  }
                }}
                disabled={selectedOptions.length < maxTopicsSelection}
              />
            </OpacityAnimation>
          ) : null}
        </AnimatePresence>
      </Row>
    </Column>
  )
}

export default TopicSelector
